export const creatVueFromElement = (element, VueRoot, Vue, isInserting) => {
  const compiled = Vue.compile(element.outerHTML)
  const Component = Vue.extend({
    ...compiled,
    provide: {
      isSitecoreRendered: isInserting
    }
  })
  const ComponentInstance = new Component({
    store: VueRoot.$store
  })
  ComponentInstance.$mount(element)
}

export const handleSitecoreChrome = (chrome, VueRoot, Vue, isInserting) => {
  Array.prototype.forEach.call(chrome.element, (element) => {
    const isPlaceholder = element.getAttribute('sc-part-of') && element.getAttribute('sc-part-of').includes('placeholder') && !element.getAttribute('sc-part-of').includes('rendering')
    if (!element.outerHTML.includes('<script') && !isPlaceholder) {
      creatVueFromElement(element, VueRoot, Vue, isInserting)
    }
  })
  // reset the chrome in Experience Editor after the Vue rendering pipeline is complete
  Sitecore.PageModes.ChromeManager.resetChromes()
}
